import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ThemeContext } from "../Theme";

import TeaserTile from "./TeaserTile";
import TeaserTileHeader from "./TeaserTileHeader";

import styles from "./UspTeaser.scss";

export function UspTeaser({ children, variant, align }) {
  let theme = "";
  theme = useContext(ThemeContext);
  const classes = classNames(styles.wrapper, styles[theme], variant, {
    [styles["left-align"]]: align === "left",
  });
  return (
    <div className={styles.uspTeaser}>
      <div className={classes}>{children}</div>
    </div>
  );
}

UspTeaser.displayName = "UspTeaser";

UspTeaser.Tile = TeaserTile;
UspTeaser.TileHeader = TeaserTileHeader;
UspTeaser.Variant = {
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
};

UspTeaser.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  variant: PropTypes.string,
  align: PropTypes.oneOf(["left", "center"]),
};

UspTeaser.defaultProps = {
  variant: UspTeaser.Variant.medium,
  align: "center",
};

export default UspTeaser;
